import { Box, Circle, Text } from '@chakra-ui/layout';
import { Select } from '@chakra-ui/select';
import { useToast } from '@chakra-ui/toast';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Button } from '@chakra-ui/button';

import {
  categoryItemsReset,
  setSelectedSchedule,
} from '../../redux/actions/actions';
import {
  getCategoryItems,
  setSessionType,
} from '../../redux/api_calls/apiCalls';
import { ReactComponent as Edit } from '../../svg/Edit.svg';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton
} from "@chakra-ui/react";
import { useDisclosure } from '@chakra-ui/react';
import {
  loadSchedule,
} from '../../redux/api_calls/apiCalls';
import { Link } from '@chakra-ui/react'

export default function ManageScheduleSlot({
  subject,
  className,
  id,
  sessionId,
  categoryId,
  categoryTitle,
  libraryId,
  libraryTitle,
  time,
  data: dataS,
  key,
  colorName,
  contentUrl
}) {
  const [selectedCategoryType, setSelectedCategoryType] = useState('-1');
  const [selectedCategoryItem, setSelectedCategoryItem] = useState('0');
  const [apiCallComplete, setApiCallComplete] = useState(false);
  const categoriesData = useSelector(
    (state) => state.categoriesState.categoriesData
  );
  const categoryItemsData = useSelector(
    (state) => state.categoryItemsState.categoryItemsData
  );
  const selectedScheduleId = useSelector(
    (state) => state.selectedScheduleIdState
  );
  const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const categoryTypeRef = useRef();
  const categoryItemsRef = useRef();
  const toast = useToast();
  const dispatch = useDispatch();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const categoryTypeChangeHandler = () => {
    if (categoryTypeRef.current.value !== '0') {
      setApiCallComplete(false);
      dispatch(categoryItemsReset());
      setIsEditing(true);
      setSelectedCategoryType(categoryTypeRef.current.value);
      dispatch(setSelectedSchedule({ scheduleId: id, sessionId: sessionId }));
      setIsLoading(true);
    }
  };

  const categoryItemChangeHandler = () => {
    if (categoryItemsRef.current.value !== '0') {
      setSelectedCategoryItem(categoryItemsRef.current.value);
    }
  };

  const setCurrentSession = async () => {
    try {
      let description = categoriesData.find(
        (category) => category.id.toString() === selectedCategoryType
      ).name;

      let response = await setSessionType(
        id,
        description,
        selectedCategoryType,
        selectedCategoryItem
      );

      if (response) {
         dispatch(
      loadSchedule(
        localStorage.getItem('startDate'),
         localStorage.getItem('endDate'),
         localStorage.getItem('class'),
      )
    );
       // window.location.reload();
        onClose();
        toast({
          title: 'Success!',
          description: 'Class details set successfully!',
          status: 'success',
          duration: 2000,
          isClosable: true,
        });
      }
    } catch (error) {
       onClose();
      toast({

        title: 'Something went wrong!',
        description: 'Error! ' + error,
        status: 'error',
        duration: 2000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    if (categoryId && libraryId) {
      setIsLoading(true);
      setSelectedCategoryType(categoryId);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (categoryItemsData.length > 0 && libraryId && categoryId && !isEditing) {
      setIsLoading(false);
      setApiCallComplete(true);
      //let selectedItem = categoryItemsData.find(item => item.id.toString() === libraryId)
      //let item = selectedItem? selectedItem.title : ''
    }
    // eslint-disable-next-line
  }, [categoryItemsData]);

  useEffect(() => {
    if (isLoading && selectedCategoryItem !== '0') {
      setCurrentSession();
    }
    // eslint-disable-next-line
  }, [selectedCategoryItem]);

  useEffect(() => {
    if (isLoading && selectedCategoryType !== '-1') {
      dispatch(getCategoryItems(selectedCategoryType, id));
    }
    // eslint-disable-next-line
  }, [selectedCategoryType]);
  const [show, setShow] = useState(false);
  const [work, setWork] = useState(true);
 
  const leave = () => {
    setWork(false);
    console.log(apiCallComplete,show);
    work && setShow(false);
  };
  const handleSizeClick = newSize => {
    onOpen();
  };
  return (
    <Box
      borderLeft='1px solid rgba(0, 0, 0, 0.1)'
      flex='1'
      height={subject ? '100%' : '160px'}
      display='flex'
      flexDir='column'
      justifyContent='center'
      alignItems='center'
      py='1'
      pl='1'
      pr='1'
      //   backgroundColor={subject ? 'white' : 'lightgray'}
      style={{ fontFamily: 'Mulish, sans-serif' }}

    >
      {subject ? (
        <>
          <Box bg={subject==='Computer Science' ? '#e5f7ff' : subject==='Physics' ? '#f0e9ff' :subject==='Data Science' ? '#deefe7':subject==='Chemistry' ? '#ffebe9' : '#f8f3d6'}  p={4} color={subject==='Computer Science' ? '#4682af' : subject==='Physics' ? '#7958c9' :subject==='Data Science' ? '#26ce83':subject==='Chemistry' ? '#fa5b59' : '#967132'}  w='100%'   borderRadius='10px'>
             <Link href={contentUrl} isExternal><Text fontWeight='800' style={{marginTop: '12px',fontSize: '15px',}}>{categoryTitle}</Text></Link>
            
            <Text style={{fontSize: '12px',float:'right'}}  d='flex' flex='1' flexDir='row'> {subject} </Text>
            <Box
          height='100%'
          width='100%'
          display='flex'
          justifyContent='center'
          alignItems='center'
          onMouseEnter={() => setShow(true)}
          onMouseLeave={leave}
        >
          <Circle
            cursor='pointer'
            width='20px'
            display= 'flex' 
            height='20px'
            borderRadius='50%'
            bg={subject==='Computer Science' ? '#e5f7ff' : subject==='Physics' ? '#f0e9ff' :subject==='Data Science' ? '#deefe7':subject==='Chemistry' ? '#ffebe9' : '#f8f3d6'}
             onClick={() => handleSizeClick(time)}
             icon={<Edit width="12" height="12"/>}
          >
          <Edit/>
            <Modal onClose={onClose} id={time} isOpen={isOpen} position="center" style={{position: 'absolute', top: '50%', left: '50%'}}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{time}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
             <Select
            id='type'
            width={['100%', '100%', '80%', '70%']}
            border='1px solid rgba(0, 0, 0, 0.1)'
            borderRadius='13px'
            height='30px'
            ref={categoryTypeRef}
            value={selectedCategoryType}
            onChange={categoryTypeChangeHandler}
            fontSize='11px'
            mt='1rem'
          >
            <option value='0' key='-1'>
              Select Category
            </option>
            {categoriesData.map((category, idx) => (
              <option key={idx} value={category.id}>
                {category.name}
              </option>
            ))}
          </Select>
           <Select
              id='type'
              width={['100%', '100%', '80%', '70%']}
              border='1px solid rgba(0, 0, 0, 0.1)'
              borderRadius='13px'
              height='30px'
              ref={categoryItemsRef}
              value={selectedCategoryItem}
              onChange={categoryItemChangeHandler}
              fontSize='11px'
              disabled={
                selectedScheduleId &&
                (selectedScheduleId.scheduleId !== id ||
                  selectedScheduleId.sessionId !== sessionId)
              }
              mt='1rem'
            >
              <option value='0' key='-1'>
                Select Item
              </option>
              {categoryItemsData.map((item, idx) => (
                <option key={idx} value={item.id}>
                  {item.title}
                </option>
              ))}
            </Select>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='blue' onClick={onClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
          </Circle>
        </Box>
          </Box>
        </>
      ) : (
        <Box
          height='100%'
          width='100%'
          display='flex'
          justifyContent='center'
          alignItems='center'
          onMouseEnter={() => setShow(true)}
          onMouseLeave={leave}
        >
          
        </Box>
      )}
    </Box>
  );
}
